import { useState } from 'react';
import { Alert, Box, Button, Card, CircularProgress, Typography } from '@mui/material';
import firebase from 'src/utils/firebase';
import useAuth from 'src/hooks/useAuth';

const VerifyEmail = () => {
  const { user, logout, refreshAccountContext } = useAuth();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  const checkVerification = async () => {
    setBusy(true);
    setMessage('');
    try {
      const refreshed = await refreshAccountContext();
      if (!refreshed?.emailVerified) {
        setMessage('Your email is not verified yet. Check your inbox and try again.');
      }
    } catch (error) {
      setMessage(error?.response?.data?.error || error.message || 'Unable to refresh verification status.');
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    setBusy(true);
    setMessage('');
    try {
      await firebase.auth().currentUser.sendEmailVerification({
        url: `${window.location.origin}/account/login`
      });
      setMessage('A new verification email was sent.');
    } catch (error) {
      setMessage(error.code === 'auth/too-many-requests'
        ? 'Please wait before requesting another verification email.'
        : error.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" p={3}>
      <Card sx={{ p: 4, width: '100%', maxWidth: 520 }}>
        <Typography variant="h2" gutterBottom>Verify your email</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          We sent a verification link to {user?.email}. Verify it before using your shop account.
        </Typography>
        {message && <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>}
        <Button fullWidth variant="contained" onClick={checkVerification} disabled={busy}>
          {busy ? <CircularProgress size={20} /> : 'I verified my email'}
        </Button>
        <Button fullWidth sx={{ mt: 1 }} onClick={resend} disabled={busy}>Resend verification email</Button>
        <Button fullWidth sx={{ mt: 1 }} color="inherit" onClick={logout}>Sign out</Button>
      </Card>
    </Box>
  );
};

export default VerifyEmail;
